import { render, staticRenderFns } from "./BusinessUsers.vue?vue&type=template&id=6ff4a7da"
import script from "./BusinessUsers.vue?vue&type=script&lang=js"
export * from "./BusinessUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports